import {FromMessageInterface} from '../http/from-message.interface';
import {ApiCountryResponse} from './http/api-country-response';

export class Country implements FromMessageInterface<ApiCountryResponse> {

  public alpha2Code: string = '';
  public countryName: string = '';

  public fromMessage(message: ApiCountryResponse): this {
    this.alpha2Code = message.alpha2Code;
    this.countryName = message.countryName;
    return this;
  }

  public toString(): string {
    return this.countryName;
  }

}
